import { useRouter } from 'next/navigation';
import React, { useContext, useEffect } from 'react';

import { AppContext } from '../../App';
import { KDSPermission } from '../../libs';
import { getDefaultRoute } from '../../libs/utils/getDefaultRoute';

interface ProtectedRouteProps {
  permission: KDSPermission;
  children: React.ReactNode;
}

const ProtectedRoute = ({ permission, children }: ProtectedRouteProps) => {
  const { user } = useContext(AppContext);
  const router = useRouter();
  const allowed = user.permissions?.includes(permission) === true;
  const defaultRoute = getDefaultRoute(user.permissions ?? []);

  useEffect(() => {
    if (!allowed) {
      router.replace(defaultRoute);
    }
  }, [allowed, defaultRoute, router]);

  return allowed ? children : null;
};

export default ProtectedRoute;
